import React, {Fragment, useEffect, useState} from "react";
import {withRouter} from "react-router-dom";
import {spinnerOff, spinnerOn} from "../../components/Spinner";
import {getProject, post} from "../../api";
import {confirmAlert} from "react-confirm-alert";
import Alert from "../../components/Alert";
import ViewType from "../../components/ViewType";
import ProjectsGrid from "../../components/ProjectsGrid";
import ProjectsList from "../../components/ProjectsList";


export default withRouter(function InDevelopment(props) {
    const {context, history, cardview, onViewTypeChange, projectList} = props;
    const [projects, setProjects] = useState([]);
    const [refreshProjects, setRefreshProjects] = useState(true);
    const [isLoading, setIsLoading] = useState(false);    

    useEffect(() => {
        async function getProjects() {
            if ((projects && projects.length < 1) || refreshProjects) {
                spinnerOn();
                setIsLoading(true);
                let project = {};
                project.projectStatus = "D";
                const result = await post(`projects`, "", project);
                setProjects(result.projects);
                spinnerOff();
                setIsLoading(false);
            }
        }

        getProjects();
    }, [refreshProjects]);

    function invalidDataConfirm() {
        let msg = "This project was updated by other user, Reloading..";
        confirmAlert({
            customUI: ({onClose}) => {
                return (
                    <Alert msg={msg} onClose={onClose}/>
                );
            }
        });
    }

    async function editProject(project) {
        context.setProjectTab('development');
        let verifyProject = await getProject(project.id);
        if (verifyProject.projectStatus !== "D") {
            invalidDataConfirm();
            setRefreshProjects(true);
            return;
        }
        context.setActiveProject(project);
        history.push(`/development/${project.id}`);
    }

    return (
        <Fragment>
            <div style={{
                display: "flex",
                flexDirection: "row",
                flewGrow: 1,
                justifyContent: 'center',
                paddingRight: '16px',
                paddingBottom: '16px'
            }}>
                <div style={{flexGrow: 1}}/>
                <ViewType onViewTypeChange={onViewTypeChange} tabView={'development'}/>
            </div>
            {cardview === "cardview" ?
                <ProjectsGrid projects={projectList(projects)}
                              history={history}
                              context={context}
                              onButtonClick={editProject}
                              isLoading={isLoading}   
                              {...props} /> :
                <ProjectsList projects={projectList(projects)}
                              onButtonClick={editProject}
                              {...props}
                              />
            }
          {}
        </Fragment>
    );
})
